import { useCallback } from "react";

import { useQuery } from "hooks";

export default function useImportedMeetingTypes() {
  const factory = useCallback(() => {
    const query = `
      query getSyncedMeetingTypes {
        hub {
          importedMeetingTypes {
            externalId
            name
            meetingDatesCount
            isExcluded
          }
        }
      }
    `;

    const resolver = ({ data: { hub }, errors }) => {
      if (errors?.length > 0) throw errors;
      return hub?.importedMeetingTypes?.map((status) => {
        return { ...status, count: status.meetingDatesCount };
      });
    };

    return { query, resolver };
  }, []);

  const { loading, data, error, reloadData, isEmpty, numOfFetches } =
    useQuery(factory);

  return {
    loading: loading || numOfFetches === 0,
    data: data,
    isEmpty: isEmpty,
    error: error
      ? `${
          error[0]?.message || "Failed to load meeting types table"
        }. Please refresh the page or contact support for further assistance.`
      : null,
    reloadData: reloadData,
  };
}
